import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { ReactComponent as Micro } from "./../../assets/icons/micro.svg";
import { useDispatch, useSelector } from "react-redux";
import { textChange } from "../../store/slices/textSlice";
import { useLocation } from "react-router-dom";

const Searchbar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const text = useSelector((state) => state?.text?.value);
  const [searchInput, setSearchInput] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();

  const filteredOrders = (e) => {
    dispatch(textChange(e.target.value));
  };

  useEffect(() => {
    setSearchInput("");
  }, [location, dispatch]);

  return (
    <div className="w-full">
      <Input
        className={`w-40 ml-3 lg:ml-1 h-5 rounded-md transition-colors bg-lightGrey !border-none ${
          isHovered || isFocused ? "border-primaryBlue" : "border-gray-300"
        }`}
        placeholder="Search Anything..."
        value={searchInput}
        prefix={<Micro />}
        onPressEnter={filteredOrders}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(e) => setSearchInput(e.target.value)}
      />
    </div>
  );
};

export default Searchbar;
